// extracted by mini-css-extract-plugin
export default {"root":"sizeGrid_root__puFpb","head":"sizeGrid_head__LtMdQ","close":"sizeGrid_close__oyqWC","table":"sizeGrid_table__zKxUt"};